<template>
  <nav id="nav" class="bg-primary-sub">
    <div class="">
      <el-menu
        :default-active="nav.current"
        class="menu"
        mode="horizontal"
        background-color="F9C14C"
        text-color="#fff"
        active-text-color="#000"
        @select="handleSelect"
      >
        <el-menu-item
          class="gradient-btn scale fs-xxl"
          :index="item.route"
          v-for="item in nav.list"
          :key="item.name"
          >{{ item.name }}</el-menu-item
        >
      </el-menu>
    </div>
  </nav>
</template>

<script setup>
import { reactive, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import { NAV_LIST } from '@/config/constant'

const $router = useRouter()
const route = useRoute()

const nav = reactive({
  list: NAV_LIST,
  current: ''
})

const handleSelect = (route) => {
  if (route.path === route) return
  $router.push(route)
}

watch(
  () => $router.currentRoute.value,
  (nVal) => {
    let { path, params, name } = nVal
    if (
      params &&
      (name === 'NewsDetail' || name === 'PhotoAlbum' || name === 'VideoAlbum')
    ) {
      const [value] = path.split('/').filter((item) => item)
      path = '/' + value
    }
    nav.current = path
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
#nav {
  .menu {
    border: none;
    ::v-deep {
      .el-sub-menu {
        &__title:hover {
          background-color: #f9c14c !important;
        }
      }
      .el-menu {
        &-item {
          height: 2.75rem;
          padding: 0 2%;
          &.is-active {
            border-bottom: none;
            background-color: #f9c14c;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.el-menu {
  &--popup {
    background-color: unset;
    background: linear-gradient(180deg, #0899a8, #01626b);
  }
}
</style>
